import script from "./TamButtons.vue?vue&type=script&lang=js"
export * from "./TamButtons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__